export const LEADREGISTRATION = 'LEADREGISTRATION';
export const LEADREGISTRATION_PENDING = `${LEADREGISTRATION}_PENDING`;
export const LEADREGISTRATION_FAILED = `${LEADREGISTRATION}_FAILED`;
export const LEADREGISTRATION_SUCCESS = `${LEADREGISTRATION}_SUCCESS`;
